import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { Input } from "./ui/input";
import { api } from "../lib/api";

export const RENTED_WARN = "الرجاء عدم نسيان تسجيلهم في الحسابات المستأجرة";

export const PlatformPickDialog = ({ emp, platforms, onClose, onSaved }) => {
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const [rented, setRented] = useState({});
  useEffect(() => { if (emp) { setSel([...new Set([...(emp.declared || []), ...(emp.inferred || [])])]); setRented(emp.rented || {}); } }, [emp]);
  const setR = (p, k, v) => setRented((r) => ({ ...r, [p]: { ...(r[p] || {}), [k]: v } }));
  const toggle = (p) => setSel((s) => (s.includes(p) ? s.filter((x) => x !== p) : [...s, p]));
  const save = async () => {
    setBusy(true);
    try {
      await api.setEmpPlatforms(emp.id, sel, rented);
      const primary = (emp.declared || [])[0];
      const added = sel.filter((p) => !(emp.declared || []).includes(p));
      if (sel.length > 1 || (primary && added.length)) toast.warning(RENTED_WARN, { duration: 9000 });
      else toast.success("تم حفظ منصات المندوب");
      onSaved?.();
      onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!emp} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm" dir="rtl" data-testid="platform-pick-dialog">
        <DialogHeader className="text-right">
          <DialogTitle>{emp?.name}</DialogTitle>
          <DialogDescription>المندوب يعمل في التطبيقات التالية — حدّد المنصات المعتمدة له:</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {platforms.map((p) => (
            <label key={p} className="flex items-center gap-2 rounded-lg border border-slate-100 px-3 py-2 text-sm hover:bg-slate-50" data-testid={`platform-pick-${p}`}>
              <Checkbox checked={sel.includes(p)} onCheckedChange={() => toggle(p)} />
              <span className="font-semibold">{p}</span>
              {(emp?.inferred || []).includes(p) && <span className="mr-auto rounded-full bg-sky-50 px-2 text-[10px] text-sky-700">من ملفات الأداء</span>}
            </label>
          ))}
        </div>
        {sel.slice(1).map((p) => (
          <div key={p} className="rounded-lg border border-violet-200 bg-violet-50/50 p-2" data-testid={`rented-${p}`}>
            <p className="mb-1 text-[11px] font-bold text-violet-800">حساب {p} المستأجر — صاحب الحساب</p>
            <div className="grid grid-cols-2 gap-1.5">
              <Input value={rented[p]?.owner_name || ""} onChange={(e) => setR(p, "owner_name", e.target.value)} placeholder="اسم صاحب الحساب" className="h-8 text-xs" data-testid={`rented-owner-name-${p}`} />
              <Input value={rented[p]?.owner_id || ""} onChange={(e) => setR(p, "owner_id", e.target.value)} placeholder="رقم معرّفه" className="h-8 text-xs" data-testid={`rented-owner-id-${p}`} />
            </div>
          </div>
        ))}
        {sel.length > 1 && <p className="rounded-lg bg-amber-50 p-2 text-xs font-semibold text-amber-800" data-testid="platform-rented-warn">⚠️ {RENTED_WARN}</p>}
        <div className="flex gap-2 pt-1">
          <Button variant="outline" size="sm" onClick={() => setSel(platforms)} data-testid="platform-pick-all">تحديد الكل</Button>
          <Button size="sm" className="mr-auto gap-1.5" disabled={busy} onClick={save} data-testid="platform-pick-save">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
